import styles from "./HighlightedText.module.less"

const HighlightedText = ({ text, query }) => {
  const needle = (query || "").trim().toLowerCase()
  const start = needle ? String(text).toLowerCase().indexOf(needle) : -1
  if (start === -1) return text

  const end = start + needle.length
  return (
    <>
      {text.slice(0, start)}
      <mark className={styles.match}>{text.slice(start, end)}</mark>
      {text.slice(end)}
    </>
  )
}

export default HighlightedText
